import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PolicyInformation from './PolicyInformation';
import PolicyDocuments from './PolicyDocuments';
import { Menu, Icon } from 'semantic-ui-react';
import HelpModal from './change/HelpModal';

const PolicyDetails = ({ activeItem, onMenuItemClick, onAddPolicy, policy }) => {
	const isAuto = useMemo(() => (policy.policyNumber ? policy.policyNumber.startsWith('PPA') && policy.status === 'In-Force' : false), [policy]);
	const canMakeChange = useMemo(() => !policy.hasPendingEndorsement || (policy.hasPendingEndorsement && policy.isPendingEndorsementMP && policy.hasEndorsementSave), [policy]);

	return (
		<div className='policy details'>
			<Menu pointing secondary stackable>
				<Menu.Item id='policyInformationBtn' name='information' active={activeItem === 'information'} onClick={onMenuItemClick}>
					<Icon name='info circle' />
					Information
				</Menu.Item>
				<Menu.Item id='policyDocumentsBtn' name='documents' active={activeItem === 'documents'} onClick={onMenuItemClick}>
					<Icon name='file text' />
					Documents
				</Menu.Item>

				<Menu.Menu position='right'>
					{isAuto && (
						<React.Fragment>
							{canMakeChange && (
								<Menu.Item id='policyMakeChangeBtn' name='makeChange' onClick={onMenuItemClick}>
									<Icon name='edit' />
									Make a Change
								</Menu.Item>
							)}

							{!canMakeChange && policy && policy.agency && (
								<HelpModal
									title='Make a Change'
									trigger={
										<Menu.Item id='policyMakeChangeBtn' name='makeChange'>
											<Icon name='edit' />
											Make a Change
										</Menu.Item>
									}
									agency={policy.agency}
									message={''}>
									<p>
										Hi! Thanks for choosing Indiana Farmers Insurance. Currently, <b>you already have</b> a change to your policy ({policy.policyNumber}) that is pending. We only allow one change at a time thus we cannot allow you to proceed.
									</p>
									<p>For further assistance or questions, please contact your agent. Thank you.</p>
								</HelpModal>
							)}
						</React.Fragment>
					)}

					<Menu.Item id='policyEditNicknameBtn' name='edit' onClick={onMenuItemClick}>
						<Icon name='edit' />
						Edit Nickname
					</Menu.Item>
					<Menu.Item id='policyRemoveBtn' name='delete' onClick={onMenuItemClick}>
						<Icon name='trash' />
						Remove
					</Menu.Item>
					<Menu.Item id='policyMobileAddBtn' className='mobileShow' name='add' onClick={onAddPolicy}>
						<Icon name='add square' />
						Add Policy
					</Menu.Item>
				</Menu.Menu>
			</Menu>

			{activeItem === 'information' ? <PolicyInformation policy={policy} /> : null}
			{activeItem === 'documents' ? <PolicyDocuments policy={policy} /> : null}
		</div>
	);
};

PolicyDetails.propTypes = {
	activeItem: PropTypes.string,
	onMenuItemClick: PropTypes.func.isRequired,
	onAddPolicy: PropTypes.func.isRequired,
	policy: PropTypes.object.isRequired,
};

export default PolicyDetails;
